module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "video-items",
    on: {
      "click": function($event) {
        return _vm.toActivityDetail(_vm.content)
      }
    }
  }, [_c('div', {
    staticClass: "active-item-title"
  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _vm._l((_vm.content.pics_url), function(item, i) {
    return _c('div', {
      staticClass: "video-box"
    }, [_c('img', {
      staticClass: "video-img",
      attrs: {
        "src": item,
        "alt": ""
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "on-play",
      attrs: {
        "src": require("../../assets/images/activity/icon-video-play@2x.png"),
        "alt": "",
        "srcset": ""
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "video-bottom"
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5a7f900","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/Activity2.vue
// module id = 1540
// module chunks = 0